import { render } from "./MenuCard.vue?vue&type=template&id=7453c152"
import script from "./MenuCard.vue?vue&type=script&lang=js"
export * from "./MenuCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/MenuCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7453c152"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7453c152', __exports__)) {
    api.reload('7453c152', __exports__)
  }
  
  module.hot.accept("./MenuCard.vue?vue&type=template&id=7453c152", () => {
    api.rerender('7453c152', render)
  })

}


export default __exports__